"use client";

import React from "react";
import { Compass, User, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Documentazione Visti",
  description: "Gestione completa delle pratiche consolari per studenti e docenti. Assicuriamo che ogni documento sia conforme ai requisiti internazionali per una partenza senza intoppi.",
  icon: Compass
}, {
  title: "Itinerari di Gruppo",
  description: "Pianificazione logistica su misura per istituti scolastici. Coordiniamo trasporti, alloggi e visite didattiche per garantire un'esperienza formativa sicura e organizzata.",
  icon: Users
}, {
  title: "Assicurazioni Viaggio",
  description: "Coperture assicurative specifiche per gite scolastiche. Protezione totale per imprevisti medici, annullamenti e assistenza h24 durante tutta la durata del soggiorno all'estero.",
  icon: User
}];
export default function TherapeutischeSchwerpunkte() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222113" id="i-nostri-servizi-per-gite-scolastiche" className="bg-background text-foreground py-24 md:py-32">
      <div className="mx-auto max-w-screen-xl px-6 md:px-12">
        {}
        <h2 className="sr-only">I nostri Servizi per Gite Scolastiche</h2>
        
        <div ref={ref} className={`grid grid-cols-1 gap-8 md:grid-cols-3 transition-all duration-1000 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          {services.map((service, i) => <Card key={i} data-index={i} className="group border-none border-l-2 border-l-secondary bg-card p-10 shadow-md transition-all duration-500 hover:-translate-y-2 hover:shadow-xl hover:shadow-secondary/20 rounded-md">
              <CardHeader className="p-0 mb-6 gap-0">
                <div className="mb-6 inline-flex">
                  <service.icon className="h-8 w-8 text-secondary transition-colors duration-500 group-hover:text-primary" strokeWidth={1.5} aria-hidden="true" />
                </div>
                <CardTitle className="font-default text-2xl font-bold tracking-tight text-primary">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="p-0">
                <p className="font-sans text-base leading-relaxed text-foreground/80">
                  {service.description}
                </p>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}